// extracted by mini-css-extract-plugin
module.exports = {"errors":"style_errors__3Youp","container":"style_container__3atdq","footerNav":"style_footerNav__1fRkB"};